import { TFunction } from "i18next";
import { useTranslation } from "react-i18next";

import { colors } from "#app/theme/v2/colors";
import { spacing } from "#app/theme/v2/spacing";
import { IconButton } from "#components/atoms/IconButton/IconButton";
import { Skeleton, TitleSkeleton } from "#components/atoms/Skeleton/Skeleton";
import { Text } from "#components/atoms/Typographies/Text";
import { Title } from "#components/atoms/Typographies/Title";
import { Icon } from "#shared/icons/Icon";
import { Flex } from "#shared/view/components/Flex";
import { Group } from "#shared/view/components/Group";
import { Stack } from "#shared/view/components/Stack";
import { formatDate } from "shared";

const buildSubtitle = (t: TFunction, clientName?: string, createdAt?: Date, lineNumber?: number) =>
  [
    clientName,
    createdAt ? t("quoteRequestV2.header.createdAt", { date: formatDate(createdAt) }) : undefined,
    lineNumber ? t("quoteRequestV2.header.lineNumber", { count: lineNumber }) : undefined,
  ]
    .filter(Boolean)
    .join(" · ");

const QuoteRequestNameHeaderSkeleton = () => (
  <>
    <TitleSkeleton size="small" width={280} />
    <Skeleton variant="line" height={22} width={208} />
  </>
);

type QuoteRequestNameHeaderProps = {
  quoteRequestName?: string;
  clientName?: string;
  createdAt?: Date;
  lineNumber?: number;
  isLoading?: boolean;
  onGoBack: () => void;
};
export const QuoteRequestNameHeader = ({
  quoteRequestName,
  clientName,
  createdAt,
  lineNumber,
  isLoading = false,
  onGoBack,
}: QuoteRequestNameHeaderProps) => {
  const { t } = useTranslation();

  return (
    <Group gap={spacing[4]} style={{ flex: "1 0 0", minWidth: 0 }}>
      <IconButton variant="secondary" size="sm" aria-label="back" onClick={onGoBack}>
        <Icon name="chevronLeft" size={16} />
      </IconButton>
      <Stack gap={spacing[1.5]}>
        {isLoading ? (
          <QuoteRequestNameHeaderSkeleton />
        ) : (
          <>
            <Title size="small">{quoteRequestName}</Title>
            <Flex gap={spacing[1]} align="center">
              <Text color={colors.text.secondaryDefault}>
                {buildSubtitle(t, clientName, createdAt, lineNumber)}
              </Text>
            </Flex>
          </>
        )}
      </Stack>
    </Group>
  );
};
